var map = {
	"./AntSim/Content.jsx": 305,
	"./AntSim/Media/Code.jsx": 6349,
	"./AntSim/Summary.jsx": 3912,
	"./DiscoZoo/Content.jsx": 1706,
	"./DiscoZoo/Media/Code.jsx": 1269,
	"./DiscoZoo/Summary.jsx": 8487,
	"./MayoProof/Content.jsx": 1608,
	"./MayoProof/Summary.jsx": 568,
	"./MyWebsite/Content.jsx": 6605,
	"./MyWebsite/Media/Code.jsx": 5208,
	"./MyWebsite/Summary.jsx": 8118,
	"./ProjectContent.jsx": 9130,
	"./ProjectSummary.jsx": 144,
	"./Puzzlerama/Content.jsx": 7182,
	"./Puzzlerama/Media/Code.jsx": 3685,
	"./Puzzlerama/Pipes1.jsx": 5707,
	"./Puzzlerama/Summary.jsx": 5228,
	"./Rubiks/Content.jsx": 7477,
	"./Rubiks/Media/code.jsx": 5392,
	"./Rubiks/Summary.jsx": 2697,
	"./SphincsPlusFault/Content.jsx": 7277,
	"./SphincsPlusFault/Summary.jsx": 8692,
	"./Wordle/Content.jsx": 3284,
	"./Wordle/Media/Code.jsx": 66,
	"./Wordle/Summary.jsx": 696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5236;